<template>
  <v-text-field
      :error-messages="error"
      :label="translation(translationList.house_pad_number, 'Număr PAD')"
      v-model="padNumber"
      name="pad_number"
      :rules="padNumberValidationRules"
      @input="onInput"
      variant="outlined"
      :tile="true"
      counter="11"
  >
  </v-text-field>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, watch, toRefs} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: Number as () => number | null,
  },
  setup(props, {emit}) {
    const {modelValue} = toRefs(props);
    const padNumber = ref(modelValue.value ?? null);
    const error = ref([]);

    watch(padNumber, (newValue) => {
      const isValid = validatePadNumber(newValue);
      emit('update:modelValue', newValue ? parseInt(newValue) : null);
      emit('validation-house-status', {field: `pad_number`, isValid});
    });

    const validatePadNumber = (value: number, showErrors?: boolean): boolean => {
      error.value = [];
      if (showErrors) {
        const errors = padNumberValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return padNumberValidationRules.every(rule => rule(value) === true);
    };

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const padNumberValidationRules = [
      (v: number) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: number) => v && v.toString().length <= 11 || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
      (v: number) => v >= 0 || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    const onInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      padNumber.value = Number(input.value);
    };

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validatePadNumber(padNumber.value);
      emit('validation-house-status', {field: `pad_number`, isValid});

      window.addEventListener('validate-house', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === `pad_number`) {
        const isValid = validatePadNumber(padNumber.value, true);
        if (isValid) {
          emit('validation-house-status', {field: data.detail, isValid});
        }
      }
    };

    watch(modelValue, (newValue) => {
      padNumber.value = newValue;
    });


    return {
      padNumber,
      padNumberValidationRules,
      translationList,
      translation,
      onInput,
      error,
    };
  },
});
</script>
